import { useState } from "react";
import { BadgeCheck, Users, MapPin, Flag, ShieldAlert } from "lucide-react";
import ReportModal from "@/components/ReportModal";
import { CATEGORY_STYLES } from "@/lib/api";

export default function CommunityCard({ community }) {
  const [reportOpen, setReportOpen] = useState(false);

  return (
    <div data-testid={`community-card-${community.id}`} className="card-lift bg-white rounded-2xl border border-slate-200 shadow-[0_8px_32px_rgba(0,0,0,0.04)] p-5 flex flex-col gap-3">
      {community.safety_flag && (
        <div data-testid={`safety-warning-${community.id}`} className="bg-rose-50 border border-rose-200 rounded-xl px-3 py-2 flex items-center gap-2">
          <ShieldAlert className="w-4 h-4 text-rose-600 shrink-0" />
          <p className="text-xs font-bold text-rose-700">Peringatan Keamanan — Pendaftaran relawan ditangguhkan selama peninjauan.</p>
        </div>
      )}
      <div className="flex items-start justify-between gap-2">
        <div>
          <h3 className="font-heading font-extrabold text-lg text-slate-900 flex items-center gap-1.5">
            {community.name}
            {community.verified && <BadgeCheck className="w-4 h-4 text-emerald-600 shrink-0" />}
          </h3>
          <span className={`inline-block mt-1 text-xs font-bold px-2.5 py-0.5 rounded-full ${CATEGORY_STYLES[community.category] || "bg-slate-100 text-slate-700"}`}>
            {community.category}
          </span>
        </div>
        <button
          data-testid={`report-community-btn-${community.id}`}
          onClick={() => setReportOpen(true)}
          title="Laporkan Masalah / Pengaduan"
          className="p-2 rounded-full border border-slate-200 text-slate-400 hover:text-rose-600 hover:border-rose-300 transition-colors shrink-0"
        >
          <Flag className="w-4 h-4" />
        </button>
      </div>
      <p className="text-sm text-slate-600 leading-relaxed">{community.description}</p>
      <div className="flex items-center gap-4 text-xs font-semibold text-slate-500 mt-auto">
        <span className="flex items-center gap-1"><MapPin className="w-3.5 h-3.5" />{community.city}</span>
        <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5" />{community.members} anggota</span>
      </div>
      <ReportModal open={reportOpen} onOpenChange={setReportOpen} targetType="Komunitas" targetName={community.name} />
    </div>
  );
}
